import { useRef } from "react";
import { Box } from "@mui/material";
import { useFeedWikifolioNewsQuery } from "src/api/client/feed/feed-wikifolio-news.api";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { EmptyState } from "src/components-mui/common/empty-state/empty-state";
import { useIsSectionInView } from "src/components-mui/common/jump-marks/use-is-section-in-view";
import { NewsList } from "src/components-mui/pages/detail/news/news-list";
import { NewsListSkeleton } from "src/components-mui/pages/detail/news/news-list-skeleton";
import { ITitleAndDescription } from "src/types/common";

const NEWS_LIST_SECTION_TEST_ID = "news-feed-section";

export interface INewsListSectionProps {
    wikifolioId: string;
    headline: string;
    emptyState: ITitleAndDescription;
}

export const NewsListSection = ({ wikifolioId, headline, emptyState }: INewsListSectionProps) => {
    const sectionRef = useRef<HTMLDivElement>(null);

    const isSectionVisible = useIsSectionInView({ sectionRef, threshold: 0.5, visibleOnce: true });

    const { data, isLoading } = useFeedWikifolioNewsQuery(wikifolioId, { enabled: isSectionVisible });

    return (
        <Box component="section" ref={sectionRef} data-test-id={NEWS_LIST_SECTION_TEST_ID}>
            <WfHeading component="h2" fontSize="2xl" sx={{ mb: 2 }}>
                {headline}
            </WfHeading>
            {(isLoading || data === undefined) && <NewsListSkeleton />}
            {!isLoading && data?.items?.length ? <NewsList items={data.items} /> : null}
            {!isLoading && data !== undefined && !data.items?.length ? (
                <EmptyState title={emptyState.title} description={emptyState.description} />
            ) : null}
        </Box>
    );
};
